/* eslint-disable no-nested-ternary */
import styled from '@emotion/styled';
import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const Container = styled.div`
  width: 747px;
  height: ${({ bigger,forCourse,isPaypalCardOption }) => (bigger ? '724px' : (isPaypalCardOption ? '1360px' :(forCourse ? '510px' : '450px')))};
  border-radius: 4px;
  direction:${({isRtl})=> isRtl ? 'rtl':'ltr'};
  box-shadow: 0 1px 7px 0 rgba(0, 105, 250, 0.15);
  background-color: #ffffff;
  transition: all 0.2s ease-in-out;
  opacity: 1;

  &.transitioning {
    transform-origin: center;
    transform: translate(calc(50vw - 1.5em), calc(50vh - 6em)) scale(0);
    opacity: 0.5;
  }
`;

export const Title = styled.div`
  font-family: Heebo;
  font-size: 25px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.32;
  letter-spacing: normal;
  text-align: center;
  color: #0070ba;
`;

export const Subtitle = styled.div`
  font-family: Heebo;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #233b69;
  margin-top: 3px;
`;

export const Content = styled.div`
  position: fixed;
  top: ${props => (props.big ? '118.4px' : '148.5px')};
  width: 747px;
  height: ${({ big, bigger,forCourse }) => (bigger ? '508px' : `${big ? '268.5px' : `${forCourse ? '240px' :'219.9px'}`}`)};
  top: ${({ big, bigger, forCourse }) => (bigger ? '89px' : `${big ? '118.4px' : `${forCourse ? '90px' :'148.5px'}`}`)};
`;

export const Background = props => (
  <div
    css={css`
      width: 747px;
      height: ${props.big ? '268.5px' : '219.9px'};
      border-radius: 4px;
      background-color: #edf4fc;
      position: fixed;
      top: ${props.bigger ? '89px' : `${props.big ? '118.4px' : '148.5px'}`};
    `}
  >
    <div
      css={css`
        width: 67.6px;
        height: ${props.big ? '268.5px' : '219.9px'};
        overflow: hidden;
      `}
    >
      <div
        css={css`
          border-radius: 50%;
          width: ${props.big ? '268.5px' : '219.9px'};
          height: ${props.big ? '268.5px' : '219.9px'};
          margin-left: ${props.big ? '-200.9px' : '-152.3px'};
          background-color: #e4edf7;
        `}
      />
    </div>
  </div>
);

Background.propTypes = {
  big: PropTypes.bool,
};

export const SkipLink = props => (
  <a
    css={css`
      position: fixed;
      bottom: ${props.skipHeight}px;
      left: 34px;
      font-family: Roboto;
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.07;
      letter-spacing: 0;
      text-align: left;
      color: #0070ba;
      text-decoration: underline;
    `}
    onClick={e => props.onClick(e)}
  >
    <FormattedMessage id="onboarding.buttons.skip" />
  </a>
);

SkipLink.propTypes = {
  onClick: PropTypes.func,
  skipHeight: PropTypes.number,
};

export const TooltipSpinner = styled.div`
  left: calc(50% - 100px);
  top: calc(50% - 100px);
`;
